export default function Home() {
  return (
    <div className="min-h-screen bg-[#E8E4DC] font-mono">
      {/* Background Effects */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none"></div>
      <div className="fixed inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/60%_30%_70%_40%] bg-gradient-radial from-[#4A4A4A] via-[#6A6A6A] to-[#8A8A8A] blur-[100px] animate-pulse"></div>
        <div className="absolute top-[10%] right-[-10%] w-[550px] h-[550px] rounded-[60%_40%_30%_70%/40%_60%_70%_30%] bg-gradient-radial from-[#5A5A5A] via-[#7A7A7A] to-[#4A4A4A] blur-[100px] animate-pulse"></div>
        <div className="absolute bottom-[-15%] left-[20%] w-[650px] h-[650px] rounded-[30%_70%_70%_30%/30%_30%_70%_70%] bg-gradient-radial from-[#6A6A6A] via-[#4A4A4A] to-[#5A5A5A] blur-[100px] animate-pulse"></div>
      </div>

      <div className="relative">
        {/* Hero Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 relative overflow-hidden">
          <div className="max-w-[720px] mx-auto relative z-10">
            <div className="text-center mb-8">
              <h1 className="text-[80px] md:text-[120px] font-black leading-none tracking-tight text-[#4A4A4A] mb-6">WANTED</h1>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 mb-8">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="flex flex-col items-center mb-8 relative">
              <div className="absolute top-0 right-4 md:right-12 z-10 transform rotate-12">
                <div className="relative">
                  <div className="border-4 border-red-600 rounded-lg px-6 py-3 opacity-70">
                    <span className="text-sm md:text-base font-black text-red-600 tracking-wider uppercase">Available for Work</span>
                  </div>
                </div>
              </div>

              <div className="w-[330px] h-auto mb-6 mt-8">
                <img 
                  alt="Karim Elhawary - Corporate Lawyer" 
                  title="Karim Elhawary - Corporate Lawyer" 
                  className="w-full h-auto" 
                  src="https://framerusercontent.com/images/XteGpXOCn4knl5fdSx7wXiDg.png" 
                />
              </div>

              <div className="bg-[#4A4A4A] text-white px-8 py-3 text-center">
                <h2 className="text-xl font-bold tracking-wide">Karim Elhawary</h2>
                <p className="text-sm mt-1 opacity-90">Corporate Lawyer | Business Development Manager</p>
                <p className="text-xs mt-1 opacity-80">AI & Automation Strategist</p>
              </div>
            </div>

            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 my-8">
              <div className="h-[1px]"></div>
            </div>

            <div className="text-center mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-4">Founder | Partner manager</h3>
              <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-6 max-w-[600px] mx-auto">
                Aaron AI for automation solutions, King TUT Recruit for employment relationships & Elhawary Brothers LLC for legal services
              </p>
            </div>

            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 my-8">
              <div className="h-[1px]"></div>
            </div>

            <div className="text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-6">Have an Idea or need Help!</h3>
              <div className="flex flex-wrap justify-center gap-3 mb-6 max-w-[700px] mx-auto">
                <a href="https://twitter.com/karimElhawry89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Twitter">
                  <i className="ri-twitter-x-fill text-xl text-[#4A4A4A] hover:text-white"></i>
                </a>
                <a href="https://www.tiktok.com/@karimelhawary_3" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="TikTok">
                  <i className="ri-tiktok-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.instagram.com/elhawarykarim/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Instagram">
                  <i className="ri-instagram-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://github.com/karimelhawary89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="GitHub">
                  <i className="ri-github-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.linkedin.com/in/karim-elhawary-393358100" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="LinkedIn">
                  <i className="ri-linkedin-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.facebook.com/karim.elhawary.9/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Facebook">
                  <i className="ri-facebook-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="tel:+201000867697" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Mobile">
                  <i className="ri-phone-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="mailto:Karimelhawary89@gmail.com" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Email">
                  <i className="ri-mail-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://wa.me/201000867697" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="WhatsApp">
                  <i className="ri-whatsapp-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.youtube.com/@ElhawaryBrothers" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="YouTube">
                  <i className="ri-youtube-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.threads.net/@elhawarykarim" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Threads">
                  <i className="ri-chat-thread-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.snapchat.com/add/karimelhawary89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Snapchat">
                  <i className="ri-snapchat-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://t.me/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Telegram">
                  <i className="ri-telegram-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://discord.gg/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Discord">
                  <i className="ri-discord-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.reddit.com/user/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Reddit">
                  <i className="ri-reddit-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.twitch.tv/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Twitch">
                  <i className="ri-twitch-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.pinterest.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Pinterest">
                  <i className="ri-pinterest-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.tumblr.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Tumblr">
                  <i className="ri-tumblr-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://medium.com/@karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Medium">
                  <i className="ri-medium-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://behance.net/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Behance">
                  <i className="ri-behance-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://dribbble.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Dribbble">
                  <i className="ri-dribbble-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://stackoverflow.com/users/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Stack Overflow">
                  <i className="ri-stack-overflow-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.producthunt.com/@karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Product Hunt">
                  <i className="ri-product-hunt-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.spotify.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Spotify">
                  <i className="ri-spotify-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://soundcloud.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="SoundCloud">
                  <i className="ri-soundcloud-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://vimeo.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Vimeo">
                  <i className="ri-vimeo-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://patreon.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Patreon">
                  <i className="ri-patreon-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://ko-fi.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Ko-fi">
                  <i className="ri-cup-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://buymeacoffee.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Buy Me a Coffee">
                  <i className="ri-cup-line text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.paypal.me/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="PayPal">
                  <i className="ri-paypal-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://venmo.com/karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Venmo">
                  <i className="ri-bank-card-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://cash.app/$karimelhawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-transparent border-2 border-dashed border-[#4A4A4A] hover:bg-[#4A4A4A] hover:text-white transition-colors cursor-pointer" title="Cash App">
                  <i className="ri-money-dollar-circle-fill text-xl text-[#4A4A4A]"></i>
                </a>
              </div>
              <p className="text-sm text-[#4A4A4A] leading-relaxed max-w-[600px] mx-auto">
                Never hesitate to Contact me, 24/7 we promise you professionally containment and covering troubles even before being in a trouble.
              </p>
            </div>

            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2">
              <div className="h-[1px]"></div>
            </div>

            <div className="text-center mt-8">
              <a href="#intro" className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold tracking-wide uppercase cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap">
                Explore More ↓
              </a>
            </div>
          </div>
        </section>

        {/* Paralegal Services Section */}
        <section id="paralegal" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                PARALEGAL SERVICES 📜
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                I deliver professional paralegal support, ensuring all legal processes run smoothly.
              </p>
            </div>

            {/* Video Section */}
            <div className="border-4 border-dashed border-teal-600 p-4 mb-8 max-w-[900px] mx-auto">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe 
                  src="https://player.vimeo.com/video/1013380373" 
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowFullScreen
                  title="Paralegal Services Overview"
                ></iframe>
              </div>
            </div>

            {/* Drafting Legal Documents */}
            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-8 mb-8">
              <h3 className="text-3xl font-black text-[#4A4A4A] mb-4 flex items-center gap-3">
                <i className="ri-edit-line text-amber-600"></i>
                Drafting Legal Documents
              </h3>
              <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
                Legal document drafting is the cornerstone of effective legal representation. I provide precise, well-structured, and professionally drafted legal documents tailored to the unique needs of individuals, businesses, and law firms. My service ensures that every document is legally sound, adheres to jurisdictional requirements, and effectively communicates your position.
              </p>
              <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
                By offering <strong>remote legal drafting services</strong>, I bring efficiency and accessibility to your legal matters, ensuring that high-quality documents are delivered promptly and securely.
              </p>

              <h4 className="text-xl font-bold text-[#4A4A4A] mb-4 mt-8">What I Do</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-amber-50/50 border-2 border-dashed border-amber-600 p-4">
                  <h5 className="font-bold text-[#4A4A4A] mb-2">📄 Petitions</h5>
                  <p className="text-sm text-[#4A4A4A]">Drafting persuasive petitions for initiating legal actions or applications.</p>
                </div>
                <div className="bg-amber-50/50 border-2 border-dashed border-amber-600 p-4">
                  <h5 className="font-bold text-[#4A4A4A] mb-2">⚖️ Motions</h5>
                  <p className="text-sm text-[#4A4A4A]">Preparing motions to support court proceedings or advance legal arguments.</p>
                </div>
                <div className="bg-amber-50/50 border-2 border-dashed border-amber-600 p-4">
                  <h5 className="font-bold text-[#4A4A4A] mb-2">✍️ Affidavits</h5>
                  <p className="text-sm text-[#4A4A4A]">Writing affidavits that accurately reflect facts and evidence.</p>
                </div>
                <div className="bg-amber-50/50 border-2 border-dashed border-amber-600 p-4">
                  <h5 className="font-bold text-[#4A4A4A] mb-2">🔍 Discovery Requests</h5>
                  <p className="text-sm text-[#4A4A4A]">Creating clear and comprehensive discovery documents to gather necessary information.</p>
                </div>
              </div>
            </div>

            {/* How I Deliver Services */}
            <div className="bg-white/60 border-4 border-dashed border-teal-600 p-8">
              <h3 className="text-3xl font-black text-[#4A4A4A] mb-6">
                How I Deliver Legal Document Drafting Services Remotely
              </h3>

              <div className="space-y-6">
                <div className="border-l-4 border-amber-600 pl-6">
                  <h4 className="text-xl font-bold text-[#4A4A4A] mb-3 flex items-center gap-2">
                    <i className="ri-phone-line text-amber-600"></i>
                    Step 1: Initial Consultation
                  </h4>
                  <ul className="space-y-2 text-sm text-[#4A4A4A]">
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Discuss the type of document required and the purpose of the drafting.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Collect all relevant case details, facts, and supporting evidence from the client.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Clarify the jurisdiction to ensure compliance with local laws and court rules.</span>
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-teal-600 pl-6">
                  <h4 className="text-xl font-bold text-[#4A4A4A] mb-3 flex items-center gap-2">
                    <i className="ri-search-line text-teal-600"></i>
                    Step 2: Legal Research
                  </h4>
                  <ul className="space-y-2 text-sm text-[#4A4A4A]">
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>Conduct in-depth research on relevant statutes, case law, and procedural rules to ensure the document is legally accurate and persuasive.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>Identify precedents and legal arguments that strengthen the document's impact.</span>
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-amber-600 pl-6">
                  <h4 className="text-xl font-bold text-[#4A4A4A] mb-3 flex items-center gap-2">
                    <i className="ri-edit-box-line text-amber-600"></i>
                    Step 3: Drafting & Review
                  </h4>
                  <ul className="space-y-2 text-sm text-[#4A4A4A]">
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Draft the document using clear and precise language tailored to the specific legal issue.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Review the draft for accuracy, consistency, and compliance with legal standards.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Ensure proper formatting and adherence to court or jurisdictional requirements.</span>
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-teal-600 pl-6">
                  <h4 className="text-xl font-bold text-[#4A4A4A] mb-3 flex items-center gap-2">
                    <i className="ri-feedback-line text-teal-600"></i>
                    Step 4: Client Review & Revisions
                  </h4>
                  <ul className="space-y-2 text-sm text-[#4A4A4A]">
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>Share the draft with the client for feedback and approval.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-teal-600 mt-1">•</span>
                      <span>Make necessary revisions based on client input or additional information.</span>
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-amber-600 pl-6">
                  <h4 className="text-xl font-bold text-[#4A4A4A] mb-3 flex items-center gap-2">
                    <i className="ri-send-plane-line text-amber-600"></i>
                    Step 5: Final Delivery
                  </h4>
                  <ul className="space-y-2 text-sm text-[#4A4A4A]">
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Deliver the finalized document in the required format (PDF, Word, etc.).</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-amber-600 mt-1">•</span>
                      <span>Provide guidance on filing procedures or next steps, if needed.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Elhawary Brothers LLC Section */}
        <section id="intro" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20 bg-gradient-to-br from-stone-100/50 to-amber-50/30">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[42px] md:text-[56px] font-black leading-tight text-[#4A4A4A] mb-6">ELHAWARY BROTHERS LLC</h2>
              <div className="border-t-2 border-dashed border-[#4A4A4A] my-6 max-w-[600px] mx-auto"></div>
              <p className="text-lg text-[#4A4A4A] leading-relaxed mb-4 max-w-[900px] mx-auto">
                We're an <strong>Alexandria, Egypt-based law firm</strong> that's always available to answer your questions, review contracts, and help you with anything on your mind.
              </p>
              <p className="text-base text-[#4A4A4A] leading-relaxed mb-8 max-w-[900px] mx-auto">
                A leading Egyptian law firm empowering foreign companies to navigate the legal complexities of doing business in Egypt. We provide comprehensive legal services tailored to international businesses seeking to establish and grow their presence in the Egyptian market.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="#services" className="inline-block bg-amber-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                  OUR SERVICES
                </a>
                <a href="/blog" className="inline-block bg-teal-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                  BLOG POSTS
                </a>
                <a href="/legal-services" className="inline-block bg-emerald-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                  LEGAL AARON AI
                </a>
                <a href="/library" className="inline-block bg-red-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                  LEGAL LIBRARY
                </a>
                <a href="mailto:elhawarybrothersllc@gmail.com" className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer">
                  CONTACT US
                </a>
              </div>
            </div>

            {/* Video Section */}
            <div className="border-4 border-dashed border-[#4A4A4A] p-4 max-w-[900px] mx-auto">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe 
                  src="https://player.vimeo.com/video/1061589201?h=3ee40cf88f" 
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowFullScreen
                  title="Elhawary Brothers Services"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">OUR MISSION & VISION</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">The principles that guide everything we do</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-amber-100/60 to-amber-50/40 border-4 border-dashed border-amber-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-600 border-2 border-dashed border-[#4A4A4A] mb-6 mx-auto">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4 text-center">OUR MISSION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed text-center">
                  To provide exceptional legal services that empower businesses to thrive in Egypt's dynamic market. We are committed to delivering practical, innovative solutions while maintaining the highest standards of professionalism and integrity.
                </p>
              </div>

              <div className="bg-gradient-to-br from-teal-100/60 to-teal-50/40 border-4 border-dashed border-teal-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-600 border-2 border-dashed border-[#4A4A4A] mb-6 mx-auto">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4 text-center">OUR VISION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed text-center">
                  To be the leading legal partner for international businesses entering the Egyptian market, recognized for our expertise, reliability, and commitment to client success. We envision a future where legal barriers never stand in the way of business growth.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">CORE VALUES</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">The principles that guide everything we do</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">INTEGRITY</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We uphold the highest ethical standards in all our dealings, ensuring transparency and honesty with every client.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-star-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">EXCELLENCE</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We strive for excellence in every aspect of our work, continuously improving our services and expertise.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-user-heart-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">CLIENT FOCUS</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  Your success is our priority. We tailor our services to meet your unique needs and business objectives.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-lightbulb-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">INNOVATION</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We embrace modern technology and innovative approaches to deliver efficient, effective legal solutions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* US Government Procurement */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-red-50/40 to-blue-50/40">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">US GOVERNMENT PROCUREMENT</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">Expert guidance for businesses seeking to work with the US Government</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              <div className="order-2 lg:order-1">
                <div className="border-4 border-dashed border-[#4A4A4A] overflow-hidden bg-white/60">
                  <img 
                    alt="US Government Procurement" 
                    className="w-full h-full object-cover object-top" 
                    src="https://public.readdy.ai/ai/img_res/050ae41bb0af2214c2dfa2d334143ba8.jpg" 
                  />
                </div>
              </div>

              <div className="order-1 lg:order-2">
                <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 h-full">
                  <h3 className="text-3xl font-black text-[#4A4A4A] mb-6">Navigate Federal Contracting with Confidence</h3>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-4">
                    The US Government is the world's largest buyer of goods and services, spending over <strong>$600 billion annually</strong> on contracts. We help businesses understand and access these opportunities.
                  </p>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
                    Our team provides comprehensive support for companies seeking to do business with federal agencies, from registration to contract execution and compliance.
                  </p>

                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">SAM Registration Assistance</p>
                        <p className="text-sm text-[#4A4A4A]">Complete support for System for Award Management registration</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">Compliance & Regulations</p>
                        <p className="text-sm text-[#4A4A4A]">Navigate FAR, DFARS, and other federal regulations</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">Proposal Development</p>
                        <p className="text-sm text-[#4A4A4A]">Expert assistance in preparing winning proposals</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-government-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Federal Registration</h4>
                <p className="text-sm text-[#4A4A4A]">SAM.gov, CAGE codes, and DUNS number assistance</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-file-list-3-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Contract Compliance</h4>
                <p className="text-sm text-[#4A4A4A]">Ensure adherence to federal acquisition regulations</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-search-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Opportunity Identification</h4>
                <p className="text-sm text-[#4A4A4A]">Find and track relevant government contracts</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Certification Support</h4>
                <p className="text-sm text-[#4A4A4A]">Small business, veteran, and minority certifications</p>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">OUR SERVICES</h2>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">Get the legal knowledge and advice your business deserves</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-scales-3-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Legal Consultation</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Navigate the complexities of corporate law with our tailored legal consultation services. We provide comprehensive guidance on corporate structures, contract negotiations, and international trade compliance.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-building-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Company Incorporation & Registration</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Make your mark in Egypt effortlessly with our company incorporation and registration services. We handle everything from legal formalities to securing the necessary licenses.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-home-4-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Real Estate & Property Law</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Whether you're buying, leasing, or developing property in Egypt, our real estate legal experts are here to guide you through every step.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-team-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Employment & Labor Law</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Stay compliant and create a thriving work environment with our employment and labor law services. From drafting employment contracts to resolving disputes.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-exchange-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Mergers & Acquisitions</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Navigate the intricate world of M&A with confidence. Our legal team provides thorough due diligence and strategic advice on transaction structuring.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-global-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Cross-Border Legal Services</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Expand your business horizons with our cross-border legal services. From legal opinions to translation, we provide the support you need to navigate international law.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Industry Expertise */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">INDUSTRY EXPERTISE</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">Deep sector knowledge across multiple industries</p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                { icon: 'ri-building-2-line', name: 'Technology' },
                { icon: 'ri-shopping-cart-line', name: 'E-Commerce' },
                { icon: 'ri-hospital-line', name: 'Healthcare' },
                { icon: 'ri-bank-line', name: 'Finance' },
                { icon: 'ri-oil-line', name: 'Energy' },
                { icon: 'ri-building-4-line', name: 'Real Estate' },
                { icon: 'ri-restaurant-line', name: 'Hospitality' },
                { icon: 'ri-truck-line', name: 'Logistics' },
                { icon: 'ri-store-2-line', name: 'Retail' },
                { icon: 'ri-plant-line', name: 'Agriculture' }
              ].map((industry, index) => (
                <div key={index} className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-4 text-center hover:bg-white/80 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className={`${industry.icon} text-xl text-amber-700`}></i>
                  </div>
                  <p className="text-sm font-bold text-[#4A4A4A]">{industry.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* AI Chat Assistants */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-50/30 to-stone-50/30">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">CHAT WITH OUR AI</h2>
              <p className="text-lg text-[#4A4A4A] max-w-[700px] mx-auto mb-8">
                Get instant answers to your legal questions 24/7 with our intelligent AI assistants
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white/60 border-4 border-dashed border-teal-600 rounded-lg overflow-hidden shadow-2xl">
                <div className="bg-teal-600 text-white px-6 py-3 text-center">
                  <h3 className="text-xl font-bold">🇪🇬 Arabic Assistant | المساعد العربي</h3>
                  <p className="text-sm mt-1 opacity-90">For Arabic-speaking users</p>
                </div>
                <iframe 
                  src="https://www.chatbase.co/iulM72SuEso5EHol-qdQC/help" 
                  title="Arabic AI Chat Assistant" 
                  className="w-full h-[600px]"
                ></iframe>
              </div>

              <div className="bg-white/60 border-4 border-dashed border-amber-600 rounded-lg overflow-hidden shadow-2xl">
                <div className="bg-amber-600 text-white px-6 py-3 text-center">
                  <h3 className="text-xl font-bold">🇬🇧 English Assistant</h3>
                  <p className="text-sm mt-1 opacity-90">For English-speaking users</p>
                </div>
                <iframe 
                  src="https://app.simli.com/session/abc17eef-da42-4794-b552-c980c638cb99/gAAAAABpM5wHgcgWS312ZYbcVCLUr2foFG0RFq3a_6L9dlFos_DiC1VMVXhdVhDhRSWk0sh3D-Ti2VSxMGCvmQhBuNEf1NUEfI6fbQLB3iYah2XCNZaaBMk46EKnGfcRiHV7kuA-2dUETKoWbdt1hE50N0LT-JE187cpRLpC7DT449Lp0fWQKVa-Lk8uVmx0mFh75ZYEqit9fQauYEE__76nlhFvRq7EsBg2iJl3CBA34dsAZL9yPDfy9L9HZ9JdSVJ_3sFo4-QWBOYId5baxJ3altO8BNabsuIYsT1k4Lp4xN6CaYJKpW2DlOYO990PysmErnbQ4YZ1gw1c4rUF9njoU9YMZYB7hXGeoWUNLa8BQk4up04i2MpQ00-vVmSc-eMUVc3-oO9eeobL6ktK8hQJp_wtFCBkF-BNUcCtgBUObEeh2uy_4R9b5XKKfkINH4JugZNnqrYz" 
                  title="English AI Voice Assistant" 
                  className="w-full h-[600px]" 
                  allow="microphone"
                ></iframe>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-[#4A4A4A]">
                Our AI assistants can help you with contract reviews, legal questions, and service inquiries in both Arabic and English
              </p>
            </div>
          </div>
        </section>

        {/* Client Testimonials */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">CLIENT TESTIMONIALS</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">What our clients say about working with us</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Elhawary Brothers made our company registration in Egypt seamless. Their expertise and professionalism exceeded our expectations. Highly recommended!"
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Sarah Johnson</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">CEO, TechStart International</p>
                </div>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Outstanding legal support for our M&A transaction. The team's attention to detail and deep market knowledge were invaluable."
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Michael Chen</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">CFO, Global Ventures Ltd</p>
                </div>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Professional, responsive, and always available. They guided us through complex employment law matters with ease."
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Emma Williams</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">HR Director, Retail Solutions</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">FREQUENTLY ASKED QUESTIONS</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                  <span className="text-amber-600 mr-3">Q:</span>
                  How long does it take to register a company in Egypt?
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                  <span className="text-teal-600 font-bold mr-2">A:</span>
                  The company registration process typically takes 2-4 weeks, depending on the type of entity and completeness of documentation. We streamline this process to ensure the fastest possible turnaround.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                  <span className="text-amber-600 mr-3">Q:</span>
                  Do you provide services in English?
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                  <span className="text-teal-600 font-bold mr-2">A:</span>
                  Yes, we provide full legal services in both English and Arabic. Our team is fluent in both languages and experienced in working with international clients.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                  <span className="text-amber-600 mr-3">Q:</span>
                  What are your consultation fees?
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                  <span className="text-teal-600 font-bold mr-2">A:</span>
                  We offer a free initial consultation to understand your needs. Our fee structure is transparent and competitive, with options for hourly rates or fixed-fee arrangements depending on the service.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                  <span className="text-amber-600 mr-3">Q:</span>
                  Can you help with visa and work permit applications?
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                  <span className="text-teal-600 font-bold mr-2">A:</span>
                  Yes, we assist with all aspects of immigration law, including visa applications, work permits, and residency requirements for foreign nationals and their families.
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                  <span className="text-amber-600 mr-3">Q:</span>
                  Do you handle dispute resolution and litigation?
                </h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                  <span className="text-teal-600 font-bold mr-2">A:</span>
                  Yes, we provide comprehensive dispute resolution services, including negotiation, mediation, arbitration, and litigation representation in Egyptian courts.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-amber-50/30 to-stone-50/30">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">GET IN TOUCH</h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">We're here to help. Reach out to us through any of these channels</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">OFFICE LOCATION</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  Alexandria, Egypt<br />Available for in-person consultations
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">CONTACT DETAILS</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  <a href="tel:+201000867697" className="hover:text-amber-600 transition-colors cursor-pointer">+20 100 086 7697</a><br />
                  <a href="mailto:Karimelhawary89@gmail.com" className="hover:text-amber-600 transition-colors cursor-pointer">Karimelhawary89@gmail.com</a>
                </p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">AVAILABILITY</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  24/7 Support Available<br />We're always here when you need us
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-600/90 to-teal-700/90">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-white mb-6">READY TO GET STARTED?</h2>
            <p className="text-xl text-white/90 mb-8 max-w-[700px] mx-auto">
              Contact us today to discuss your legal needs and discover how we can help your business succeed in Egypt
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:Karimelhawary89@gmail.com" className="inline-block bg-amber-600 text-white px-8 py-4 text-lg font-bold border-2 border-dashed border-white hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                CONTACT US TODAY
              </a>
              <a href="#services" className="inline-block bg-transparent border-2 border-dashed border-white text-white px-8 py-4 text-lg font-bold hover:bg-white hover:text-[#4A4A4A] transition-colors whitespace-nowrap cursor-pointer">
                VIEW OUR SERVICES
              </a>
            </div>
          </div>
        </section>

        {/* Investment Guarantees & Legal Framework Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20 bg-gradient-to-br from-emerald-50/40 to-teal-50/40">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                INVESTMENT GUARANTEES IN EGYPT
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                Understanding your rights and protections under Egyptian investment law
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-white/60 border-4 border-dashed border-emerald-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 border-2 border-dashed border-[#4A4A4A] mb-6">
                  <i className="ri-shield-check-line text-3xl text-emerald-700"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4">Protection Against Nationalization</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed mb-4">
                  Companies and enterprises may not be nationalized or confiscated under Egyptian investment law. Your business assets are protected by law.
                </p>
                <ul className="space-y-2 text-sm text-[#4A4A4A]">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                    <span>Full legal protection for foreign investments</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                    <span>Constitutional guarantees against seizure</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                    <span>International treaty protections</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white/60 border-4 border-dashed border-teal-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mb-6">
                  <i className="ri-government-line text-3xl text-teal-700"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4">No Administrative Guardianship</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed mb-4">
                  It is not permissible by administrative means to impose guardianship on companies and establishments or to seize assets.
                </p>
                <ul className="space-y-2 text-sm text-[#4A4A4A]">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-1"></i>
                    <span>Freedom from arbitrary government control</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-1"></i>
                    <span>Protection of management autonomy</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-teal-600 mt-1"></i>
                    <span>Legal recourse against violations</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-gradient-to-r from-emerald-600 to-teal-600 border-4 border-dashed border-[#4A4A4A] p-8 text-white">
              <h3 className="text-3xl font-black mb-6 text-center">Key Investment Protections</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 border-2 border-dashed border-white mx-auto mb-4">
                    <i className="ri-money-dollar-circle-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold mb-2">Profit Repatriation</h4>
                  <p className="text-sm opacity-90">Free transfer of profits and capital abroad</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 border-2 border-dashed border-white mx-auto mb-4">
                    <i className="ri-scales-3-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold mb-2">Fair Treatment</h4>
                  <p className="text-sm opacity-90">Equal treatment with domestic investors</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 border-2 border-dashed border-white mx-auto mb-4">
                    <i className="ri-file-shield-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold mb-2">Legal Security</h4>
                  <p className="text-sm opacity-90">Comprehensive legal framework protection</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Legal Services Videos */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                LEARN MORE ABOUT OUR SERVICES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                Watch our detailed service videos to understand how we can help your business
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-4">
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe 
                    src="https://www.youtube.com/embed/NsGXvHvf2TU" 
                    className="absolute top-0 left-0 w-full h-full"
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                    title="Legal Services Overview"
                  ></iframe>
                </div>
                <div className="mt-4 p-4 bg-amber-50/50 border-2 border-dashed border-amber-600">
                  <h3 className="font-bold text-[#4A4A4A] mb-2">Corporate Legal Services</h3>
                  <p className="text-sm text-[#4A4A4A]">Comprehensive overview of our corporate legal solutions</p>
                </div>
              </div>

              <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-4">
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe 
                    src="https://www.youtube.com/embed/MkT2ox0daBY" 
                    className="absolute top-0 left-0 w-full h-full"
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                    title="Business Setup in Egypt"
                  ></iframe>
                </div>
                <div className="mt-4 p-4 bg-teal-50/50 border-2 border-dashed border-teal-600">
                  <h3 className="font-bold text-[#4A4A4A] mb-2">Business Setup Guide</h3>
                  <p className="text-sm text-[#4A4A4A]">Step-by-step guide to establishing your business in Egypt</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Application Form Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20 bg-gradient-to-br from-amber-50/30 to-stone-50/30">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                APPLY FOR OUR SERVICES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto mb-8">
                Ready to get started? Fill out our application form and we'll get back to you within 24 hours
              </p>
            </div>

            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-4 max-w-[1000px] mx-auto">
              <iframe 
                src="https://forms.visme.co/formsPlayer/8r66omwm-apply-here" 
                className="w-full h-[800px]"
                frameBorder="0"
                title="Application Form"
              ></iframe>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-[#4A4A4A] mb-4">
                Need help with the application? Contact us directly:
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="mailto:Karimelhawary89@gmail.com" className="inline-block bg-amber-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                  EMAIL US
                </a>
                <a href="https://wa.me/+201000867697" target="_blank" rel="noopener noreferrer" className="inline-block bg-emerald-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                  WHATSAPP
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="px-6 py-12 bg-stone-800 text-stone-200">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <img 
                    alt="Elhawary Brothers LLC" 
                    className="h-12 w-12" 
                    src="https://aaronai.my.canva.site/we-re-elhawary-brothers-for-legal-service-always-available-to-answer-your-questions-review-contracts-and-help-you-with-anything-on-your-mind/images/6d56202f5cc6c783dbd3ce2db48c755d.png" 
                  />
                  <span className="text-xl font-bold">Elhawary Brothers LLC</span>
                </div>
                <p className="text-stone-400 mb-4 max-w-md text-sm">
                  A leading Egyptian law firm empowering foreign companies to navigate the legal complexities of doing business in Egypt.
                </p>
                <div className="flex space-x-4">
                  <a href="https://www.facebook.com/profile.php?id=61557350524776" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/elhawary-brothers-llc/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill text-lg"></i>
                  </a>
                  <a href="https://www.instagram.com/elhawarybrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a href="https://www.youtube.com/@ElhawaryBrothers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-youtube-fill text-lg"></i>
                  </a>
                  <a href="https://wa.me/+201000867697" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-whatsapp-line text-lg"></i>
                  </a>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
                <ul className="space-y-2 text-sm">
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#services">Services</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#paralegal">Paralegal Services</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#intro">About Us</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/blog">Blog Posts</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/legal-services">Legal Aaron AI</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/library">Legal Library</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/">Home</a></li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-contact-info text-sm">
                  Contact Info
                </h3>
                <ul className="space-y-3 text-stone-400 text-sm">
                  <li className="flex items-start space-x-2">
                    <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                    <span>Alexandria, Egypt</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-phone-line text-amber-500 mt-1"></i>
                    <span>+201000867697</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-mail-line text-amber-500 mt-1"></i>
                    <span>elhawarybrothersllc@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-dashed border-stone-700 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-stone-400 text-xs mb-4 md:mb-0">© 2025 Elhawary Brothers LLC. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-amber-500 text-xs transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
